import { module } from 'modujs';

export default class Icons extends module {
  static CLASS_ACTIVE = 'is-active';
  static DELAY = 1500;

  constructor(m) {
    super(m);
    this.$el = this.el;
    this.$icons = this.$el.querySelectorAll('.o-icon');
    this.currentIndex = 0;
    this.interval = null;
  }

  init() {
    if (!this.$icons.length) return;

    this.activateIcon(this.currentIndex);

    this.interval = setInterval(() => {
      this.deactivateAll();
      this.currentIndex = (this.currentIndex + 1) % this.$icons.length;
      this.activateIcon(this.currentIndex);
    }, Icons.DELAY);
  }

  activateIcon(index) {
    this.$icons[index].classList.add(Icons.CLASS_ACTIVE);
  }

  deactivateAll() {
    this.$icons.forEach(icon => {
      icon.classList.remove(Icons.CLASS_ACTIVE);
    });
  }

  destroy() {
    super.destroy();
    clearInterval(this.interval);
    this.deactivateAll();
  }
}